/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'is-empty';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Cookie from 'js-cookie';
import jwt from 'jsonwebtoken';

import getCustomerAccounts from '../../actions/setupBankDetails.actions/getCustomerAcct';
import { DebitAccountCard, ErrorAlertNotification } from '../commons/index';
import bankBuildingIcon from '../../template/utils/icons/bank-building.png';
import postTreatGroupNotification from '../../actions/notification.actions/treatGroupNotification';
import { destinationAccount } from '../../middlewares/targetSavings/enterSavingDetails';
import withdrawFixTipInvestment, { deleteWithdrawFixTipInvestmentError } from
  '../../actions/investment.actions/mtLipActions/withdrawFixTip';
import withdrawMtLipInvestment, { deleteWithdrawMtLipInvestmentError } from
  '../../actions/investment.actions/mtLipActions/postMtLipWithdraw';
import withdrawFixedSaving, { deleteWithdrawFixedSavingError } from '../../actions/savings.actions/withdrawFixedSavings';

/**
 * @class SelectAccountId
 */
class SelectAccountId extends Component {
    state = {
      accountId: '',
      errors: {}
    }

    componentWillMount = () => {
      const { GetCustomerAccounts } = this.props;
      GetCustomerAccounts();
    }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  onHandleRadioButton2 = (event) => {
    this.setState({
      accountId: event.currentTarget.value,
      errors: {}
    });
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  handleDelete = () => {
    const investActionType = Cookie.getJSON('investObj');
    const savingActionType = Cookie.getJSON('savingObj');

    const actualInvestObj = investActionType || '';
    const actualSavingObj = savingActionType || '';

    if (actualInvestObj.actionType === 'fixTipAction') {
      const { DeleteWithdrawFixTipInvestmentError } = this.props;
      DeleteWithdrawFixTipInvestmentError();
    }
    if (actualInvestObj.actionType === 'mtLipAction') {
      const { DeleteWithdrawMtLipInvestmentError } = this.props;
      DeleteWithdrawMtLipInvestmentError();
    }
    if (actualSavingObj.planType === 'ETHICAL_SAVINGS' || actualSavingObj.planType === 'FIXED_SAVINGS') {
      const {
        DeleteWithdrawFixedSavingError
      } = this.props;
      DeleteWithdrawFixedSavingError();
    }
  }


  onSubmit = () => {
    const investObj = Cookie.getJSON('investObj');
    const getSavingObj = Cookie.getJSON('savingObj');

    const token = Cookie.get('jwtToken');
    const decodeToken = jwt.decode(token);
    const { customerId } = decodeToken;

    const {
      addCardDetails,
      PostTreatGroupNotification,
      history,
      planType,
      WithdrawFixTipInvestment,
      WithdrawMtLipInvestment,
      WithdrawFixedSaving
    } = this.props;

    const { accountId } = this.state;

    const mainDetails = {
      ...addCardDetails,
      accountId
    };

    const withDrawFixTipInvestObj = {
      customerId: Number(customerId),
      fixtipId: investObj ? investObj.investmentId : '',
      accountId: Number(accountId),
      withdrawTo: 1
    };

    const withDrawMtLipInvestObj = {
      customerId: Number(customerId),
      mtlipId: investObj ? Number(investObj.investmentId) : '',
      accountId: Number(accountId),
      withdrawTo: 1
    };

    const withDrawToFixSavings = {
      customerId: Number(customerId),
      fixedSavingId: getSavingObj ? getSavingObj.id : '',
      accountId: Number(accountId),
      withdrawTo: 1
    };

    if (this.isValidAccountIdCheck()) {
      const actualInvestObj = investObj || '';
      const actualSavingObj = getSavingObj ? getSavingObj.planType : {};
      if (planType === 'GROUP_TARGET_SAVINGS') {
        PostTreatGroupNotification(mainDetails, history);
        this.setState({
          errors: {},
        });
      }
      if (actualInvestObj.actionType === 'fixTipAction') {
        WithdrawFixTipInvestment(withDrawFixTipInvestObj, history);
      }
      if (actualInvestObj.actionType === 'mtLipAction') {
        WithdrawMtLipInvestment(withDrawMtLipInvestObj, history);
      }
      if (actualSavingObj === 'FIXED_SAVINGS') {
        WithdrawFixedSaving(withDrawToFixSavings, history);
      }
      if (actualSavingObj === 'ETHICAL_SAVINGS') {
        WithdrawFixedSaving(withDrawToFixSavings, history);
      }
    }
  }

  /**
   *
   * @returns {*} - state
   */
  isValidAccountIdCheck = () => {
    const { errors, isValid } = destinationAccount(
      this.state
    );
    if (!isValid) {
      this.setState({
        errors,
      });
    }
    return isValid;
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const investObj = Cookie.getJSON('investObj');
    const getSavingObj = Cookie.getJSON('savingObj');
    const actualInvestObj = investObj || '';
    const actualSavingObj = getSavingObj || '';

    const {
      customerAccounts,
      treatNotificationLoading,
      success,
      withDrawFixTipInvestIsLoading,
      withDrawMtLipInvestIsLoading,
      mtLipErrorMessage,
      fixTipErrorMessage,
      fixSavingLoading,
      fixSavingError,
    } = this.props;

    const { accountId, errors } = this.state;
    if (success) {
      window.location.href = '/user-dashboard';
    }
    return (
      <div className="modal fade" id="select_account" style={{ overflowY: 'scroll' }}>
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                {' '}
                <span> Close </span>
                {' '}
&times;
              </button>
            </div>
            <div className="modal-body">
              <div className="savings_form_inst">
                <h5 id="newSavingDetails">
                Select Destination account
                </h5>
                <br />
                <p id="dashId">Please note it is mandatory you select a destination account</p>
              </div>
              {
                mtLipErrorMessage || fixTipErrorMessage || fixSavingError ? (
                  <ErrorAlertNotification
                    errors={mtLipErrorMessage || fixTipErrorMessage || fixSavingError}
                    onClick={this.handleDelete}
                  />
                ) : ''
              }

              {
  isEmpty(customerAccounts) || customerAccounts.customerAccounts.length === 0 ? (
    <div className="text-center">
      <p
        style={{
          color: 'green'
        }}
      >
        You are yet to add a destination Bank account. Click on set up bank details to add one.
      </p>
    </div>
  ) : (
    <>
      {errors && <p className="text-danger">{errors.accountId}</p>}
      {
            customerAccounts.customerAccounts.map(account => (
              <DebitAccountCard
                key={account.id}
                src={bankBuildingIcon}
                accountNumber={account.accountNo}
                accountName={account.accountName}
                bankName={account.bankName}
                name="accountId"
                value={account.id}
                defaultChecked={accountId === account.id}
                onChange={this.onHandleRadioButton2}
              />
            ))
      }
    </>
  )
}
              <div className="btn_full_width green_btn">
                {
                        isEmpty(customerAccounts.customerAccounts) ? '' : treatNotificationLoading || withDrawFixTipInvestIsLoading || withDrawMtLipInvestIsLoading || fixSavingLoading ? (
                          <button
                            type="button"
                            onClick={this.onSubmit}
                          >
                            <i className="fa fa-spinner fa-spin" />
                            {'  '}
                            {
                              actualInvestObj.actionType === 'fixTipAction' || actualInvestObj.actionType === 'mtLipAction' || actualSavingObj.planType === 'ETHICAL_SAVINGS' || actualSavingObj.planType === 'FIXED_SAVINGS' ? 'Withdraw' : 'Accept Invitation'
              }
                          </button>
                        )
                          : (
                            <button
                              type="button"
                              onClick={this.onSubmit}
                            >
                              {
                                actualInvestObj.actionType === 'fixTipAction' || actualInvestObj.actionType === 'mtLipAction' || actualSavingObj.planType === 'ETHICAL_SAVINGS' || actualSavingObj.planType === 'FIXED_SAVINGS' ? 'Withdraw' : 'Accept Invitation'
              }
                            </button>
                          )
                      }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  customerAccounts: state.getCustomerAccounts.customerAcct,
  treatNotificationLoading: state.treatUserGroupInvitation.treatNotificationLoading,
  success: state.treatUserGroupInvitation.success,
  withDrawFixTipInvestIsLoading: state.withdrawFixLip.loading,
  withDrawMtLipInvestIsLoading: state.withdrawMtLip.loading,
  mtLipErrorMessage: state.withdrawMtLip.error,
  fixTipErrorMessage: state.withdrawFixLip.error,
  fixSavingLoading: state.WithdrawFixedSavings.loading,
  fixSavingError: state.WithdrawFixedSavings.error,
});

SelectAccountId.propTypes = {
  addCardDetails: PropTypes.shape({}),
  PostTreatGroupNotification: PropTypes.func,
  GetCustomerAccounts: PropTypes.func,
  customerAccounts: PropTypes.any,
  treatNotificationLoading: PropTypes.bool,
  success: PropTypes.bool,
  history: PropTypes.shape({}),
  withDrawFixTipInvestIsLoading: PropTypes.bool,
  withDrawMtLipInvestIsLoading: PropTypes.bool,
  DeleteWithdrawMtLipInvestmentError: PropTypes.func,
  DeleteWithdrawFixTipInvestmentError: PropTypes.func,
  mtLipErrorMessage: PropTypes.string,
  fixTipErrorMessage: PropTypes.string,
  WithdrawFixTipInvestment: PropTypes.func,
  WithdrawMtLipInvestment: PropTypes.func,
  planType: PropTypes.any,
  DeleteWithdrawFixedSavingError: PropTypes.func,
  WithdrawFixedSaving: PropTypes.func,
  fixSavingLoading: PropTypes.bool,
  fixSavingError: PropTypes.any,
};

export default withRouter(connect(mapStateToProps, {
  GetCustomerAccounts: getCustomerAccounts,
  PostTreatGroupNotification: postTreatGroupNotification,
  WithdrawFixTipInvestment: withdrawFixTipInvestment,
  WithdrawMtLipInvestment: withdrawMtLipInvestment,
  DeleteWithdrawMtLipInvestmentError: deleteWithdrawMtLipInvestmentError,
  DeleteWithdrawFixTipInvestmentError: deleteWithdrawFixTipInvestmentError,
  WithdrawFixedSaving: withdrawFixedSaving,
  DeleteWithdrawFixedSavingError: deleteWithdrawFixedSavingError
})(SelectAccountId));
